import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import { containedButtonStyle, textButtonStyle } from '@/theme';
import { abyssColors } from '@/theme/colors';

type MoveToWorkpackDialogProps = {
  isOpen: boolean;
  handleWorkpackDialogClose: React.Dispatch<React.SetStateAction<boolean>>;
  handleCloseAddDialog: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  selectedPointOfInterestsLength: number;
};

export const MoveToWorkpackDialog = ({
  isOpen,
  handleWorkpackDialogClose,
  handleCloseAddDialog,
  title,
  selectedPointOfInterestsLength,
}: MoveToWorkpackDialogProps) => {
  return (
    <Dialog open={isOpen} maxWidth="sm" fullWidth sx={{ radius: 2 }}>
      <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => {
          handleWorkpackDialogClose(false);
          handleCloseAddDialog(false);
        }}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ mb: 4, p: 2 }}>
        <Typography
          sx={{
            fontSize: '1.5rem',
            color: abyssColors.primary[400],
          }}
        >
          Some of the POIs are not showing in the workpack because of your applied query or filters.
          Do you still want to change the status of all POIs?
        </Typography>
      </DialogContent>
      <Divider />
      <Divider orientation="horizontal" />
      <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <Typography
            noWrap
            sx={{
              ml: 1,
              fontWeight: 'bold',
              fontSize: '1.5rem',
              color: abyssColors.primary[300],
              minWidth: '6rem',
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            Changing status of:
          </Typography>
          <Typography
            noWrap
            sx={{
              ml: 1,
              fontWeight: 'bold',
              fontSize: '1.5rem',
              color: abyssColors.primary[500],
              minWidth: '6rem',
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            {selectedPointOfInterestsLength} POIs
          </Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            size="small"
            sx={{ mr: 2, ...textButtonStyle }}
            onClick={() => {
              handleWorkpackDialogClose(false);
              handleCloseAddDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ ...containedButtonStyle }}
            onClick={() => handleWorkpackDialogClose(false)}
          >
            Proceed
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
